import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { keysToCamel } from "@lib/snakeTocamel"
import Storage from "@lib/storage"

const initialState = {
    searchSuggestions: [],
    searchResults: [],
    recentSearches: {},
    isError: false,
}

export const labsSearchSlice = createSlice({
    name: "labsSearch",
    initialState: initialState,
    reducers: {
        fetchRecentSearches: (state) => {
            let recentSearchLocal = Storage.get("recent_search_labs_dweb") || {}
            state.recentSearches = recentSearchLocal
        },
        addRecentSearch: (state, action) => {
            state.recentSearches[action.payload.id] = action.payload
            Storage.set("recent_search_labs_dweb", state.recentSearches)
        },
        clearRecentSearch: (state) => {
            state.recentSearches = {}
            setTimeout(() => Storage.set("recent_search_labs_dweb", {}))
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchLabsSearchResults.fulfilled, (state, action) => {
            state.searchResults = action.payload
            state.isError = false
        }),
            builder.addCase(fetchLabsSearchResults.rejected, (state, action) => {
                state.searchResults = action.payload
                state.isError = true
            }),
            builder.addCase(fetchLabsSearchSuggestion.fulfilled, (state, action) => {
                state.searchSuggestions = action.payload
                state.isError = false
            }),
            builder.addCase(fetchLabsSearchSuggestion.rejected, (state, action) => {
                state.searchSuggestions = action.payload
                state.isError = true
            })
    },
})

const parseData = (data) => {
    if (!data) return
    const parsedData = {
        limit: data.limit,
        cta: data.cta,
        title: data.title,
        results: data.results?.map((item) => ({
            ...keysToCamel(item),
            mixPanelData: item.mix_panel_data,
        })),
    }

    return parsedData
}

const parseWidgets = (data) => {
    if (!data) return
    const parsedResponse = data.map((item) => ({
        data: item.data && parseData(item.data),
        type: item.type,
        mixPanelData: item.mix_panel_data,
    }))
    return parsedResponse
}

export const fetchLabsSearchResults = createAsyncThunk(
    "labSearch/fetchLabsSearchResults",
    async (_arg, { extra, rejectWithValue }) => {
        const url = `/api/labs/v1/search/auto-complete`
        const { api } = extra

        try {
            const response = await api.get(url, { params: _arg })
            if (response?.is_success) {
                const parsedData = parseWidgets(response.data?.query_results)
                return Promise.resolve(parsedData)
            }
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)

export const fetchLabsSearchSuggestion = createAsyncThunk(
    "labSearch/fetchLabsSearchSuggestion",
    async (_arg, { extra, rejectWithValue }) => {
        const url = `/api/labs/v1/search/suggestions`
        const { api } = extra

        try {
            const response = await api.get(url, { params: _arg })

            if (response?.is_success) {
                const parsedData = parseWidgets(response.data?.suggestions)
                return Promise.resolve(parsedData)
            }
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)

export const { fetchRecentSearches, addRecentSearch, clearRecentSearch } = labsSearchSlice.actions

export const labsSearchReducer = labsSearchSlice.reducer
